import React, { useEffect } from "react";
import { useStoreState, createComponentStore } from "easy-peasy";
import { Descriptions, Spin, Tag } from "antd";
import UserStoreModel, { ACTION_TYPES } from "store/models/user";

const useUserStore = createComponentStore(UserStoreModel);

export default function UserProfilePage({ ...props }) {
  const { user } = useStoreState((store) => store.auth);
  const [store, actions] = useUserStore();

  useEffect(() => {
    actions.getUserById({ object: { id: user.id } });
  }, []);

  return (
    <Spin spinning={store.process === ACTION_TYPES.FETCHING_USER}>
      <Descriptions title="Bilgilerim" column={{ xl: 3, lg: 3, md: 1 }}>
        <Descriptions.Item label="Ad Soyad">
          {store.user.name} {store.user.surname}
        </Descriptions.Item>
        <Descriptions.Item label="Durum" span={2}>
          <>
            {store.user.locked ? <Tag color="blue">Kilitli</Tag> : null}
            <Tag color={store.user.confirmed ? "green" : "orange"}>
              {store.user.confirmed ? "Onaylı" : "Onay Bekliyor"}
            </Tag>
          </>
        </Descriptions.Item>
        <Descriptions.Item label="Telefon">
          {store.user.phone}
        </Descriptions.Item>
        <Descriptions.Item label="E-Posta" span={2}>
          {store.user.email}
        </Descriptions.Item>
        <Descriptions.Item label="Kullanıcı Grubu">
          {store.user.usergroup?.name || "-"}
        </Descriptions.Item>
        <Descriptions.Item label="Kullanıcı Birimi">
          {store.user.userUnit?.description || "-"}
        </Descriptions.Item>
      </Descriptions>
    </Spin>
  );
}
